import PropTypes from "prop-types";
import { AppBar, Box, Tab, Tabs } from "@mui/material";
import { useState } from "react";
import { makeStyles } from "@material-ui/styles";
import NotesTab from "../../../../Components/NotesTab";
import ConnectedAccountsTab from "../../../../Components/ConnectedAccountsTab";
import ProspectTab from "../../../../Components/ProspectTab";
import TaskTab from "../../../../Components/TaskTab";
import ProfileTab from "./ProfileTab";
import { useAuth0 } from "@auth0/auth0-react";

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box p={3}>{children}</Box>}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
    },
}));

const SimpleTabs = ({ applicant_id, prospectData, addNoteData, editNoteData, deleteNoteData, setSnackbarMsg, setSnackbarOpen, currentApplicantData, setIsConnectAccountModalOpen, updateFileList, updateTourList, setAddTourModalOpen, setEditTourData, setTourTimeSlotError, updateMandatoryChecks, setLoading, updateTaskList, addTaskList, deleteTaskList, followUpList, setFollowUpList, setFollowUpEditData, setOpenFollowUpModal }) => {
    const { user, isAuthenticated } = useAuth0();
    const classes = useStyles();
    const [tabValue, setTabValue] = useState(0);

    return (<div className={classes.root}>
        <AppBar position="static">
            <Tabs
                value={tabValue}
                onChange={(event, newValue) => setTabValue(newValue)}
                aria-label="simple tabs example"
                variant="scrollable"
                scrollButtons="auto"
            >
                <Tab label="Profile" {...a11yProps(0)} key={0} value={0} />
                <Tab label="Tasks" {...a11yProps(1)} key={1} value={1} />
                {prospectData?.all_applicants?.map((item, index) => {
                    if (item?.is_submitted === 1) {
                        return <Tab key={index + 2} value={index + 2} label={item?.full_name} {...a11yProps(index + 2)} />;
                    } else {
                        return null;
                    }
                })}
                {prospectData?.all_applicants?.map((item, index) => {
                    return <Tab key={index + 1} value={prospectData?.all_applicants?.length + index + 2} label={prospectData?.all_applicants?.length > 1 ? 'Conected Account for ' + item?.first_name : 'Conected Accounts'} {...a11yProps(prospectData?.all_applicants?.length + index + 2)} />;
                })}
                {(isAuthenticated && user["https://propertydek.com/permissions"].indexOf("prospect-note:read") > -1) && <Tab key={prospectData?.all_applicants?.length + 3} value={(prospectData?.all_applicants?.length * 2) + 2} label={"Notes"} {...a11yProps((prospectData?.all_applicants?.length * 2) + 2)} />}
            </Tabs>
        </AppBar>
        <TabPanel value={tabValue} index={0} key={0}>
            <ProfileTab
                currentApplicantData={currentApplicantData}
                setLoading={setLoading.bind(this)}
            />
        </TabPanel>
        <TabPanel value={tabValue} index={1} key={1}>
            <TaskTab
                prospectData={prospectData}
                updateTourList={updateTourList.bind(this)}
                setAddTourModalOpen={setAddTourModalOpen.bind(this)}
                setEditTourData={setEditTourData.bind(this)}
                setSnackbarMsg={setSnackbarMsg.bind(this)}
                setSnackbarOpen={setSnackbarOpen.bind(this)}
                setTourTimeSlotError={setTourTimeSlotError.bind(this)}
                updateMandatoryChecks={updateMandatoryChecks.bind(this)}
                updateTaskList={updateTaskList.bind(this)}
                addTaskList={addTaskList.bind(this)}
                deleteTaskList={deleteTaskList.bind(this)}
                followUpList={followUpList}
                setFollowUpList={setFollowUpList}
                setFollowUpEditData={setFollowUpEditData}
                setOpenFollowUpModal={setOpenFollowUpModal.bind(this)}
            />
        </TabPanel>
        {prospectData?.all_applicants?.map((item, index) => {
            if (item?.is_submitted === 1) {
                return <TabPanel value={tabValue} index={index + 2} key={index + 2}>
                    <ProspectTab applicantData={item} apartment={prospectData?.apartment} applicant_index={index} no_of_applicants={prospectData?.no_of_applicants} updateFileList={updateFileList.bind(this)} setSnackbarMsg={setSnackbarMsg.bind(this)} setSnackbarOpen={setSnackbarOpen.bind(this)} />
                </TabPanel>;
            } else {
                return null;
            }
        })}

        {prospectData?.all_applicants?.map((item, index) => {
            return <TabPanel value={tabValue} index={prospectData?.all_applicants?.length + index + 2} key={prospectData?.all_applicants?.length + index + 2}>
                <ConnectedAccountsTab prospect={item} setIsConnectAccountModalOpen={setIsConnectAccountModalOpen.bind(this)} setSnackbarMsg={setSnackbarMsg.bind(this)} setSnackbarOpen={setSnackbarOpen.bind(this)} />
            </TabPanel>;
        })}

        {(isAuthenticated && user["https://propertydek.com/permissions"].indexOf("prospect-note:read") > -1) && <TabPanel value={tabValue} index={(prospectData?.all_applicants?.length * 2) + 2} key={(prospectData?.all_applicants?.length * 2) + 2}>
            <NotesTab
                addNoteData={addNoteData.bind(this)}
                editNoteData={editNoteData.bind(this)}
                deleteNoteData={deleteNoteData.bind(this)}
                applicant_id={applicant_id}
                setSnackbarMsg={setSnackbarMsg.bind(this)}
                setSnackbarOpen={setSnackbarOpen.bind(this)}
                prospectData={prospectData}
            />
        </TabPanel>}

    </div >);

}

export default SimpleTabs;